const localization = {
  nl: {
    form: {
      labelName: 'Uw naam',
      labelEmail: 'Uw e-mailadres',
      labelMessage: 'Uw vraag of bericht',
      submit: 'Verzenden',
      id: 'PJyldOca3WLh',
    },
    feedback: {
      genericError: 'Er is iets misgegaan, probeer het later nog eens.',
      noName: 'Voer uw naam in.',
      noEmail: 'Voer uw e-mailadres in.',
      noMessage: 'Voer een bericht in.',
      success: 'Uw bericht is verzonden!',
    },
  },
  de: {
    form: {
      labelName: 'Ihre Name',
      labelEmail: 'Ihre E-Mail-Adresse',
      labelMessage: 'Ihre Frage oder Nachricht',
      submit: 'Senden',
      id: '0P5oG3fvfJPK',
    },
    feedback: {
      genericError:
        'Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut.',
      noName: 'Geben Sie Ihre Name.',
      noEmail: 'Geben Sie Ihre E-Mail-Adresse.',
      noMessage: 'Geben Sie ein Nachricht.',
      success: 'Ihre Nachricht wurde gesendet!',
    },
  },
  en: {
    form: {
      labelName: 'Your name',
      labelEmail: 'Your e-mailaddress',
      labelMessage: 'Your question or message',
      submit: 'Send',
      id: 'Nk3P01nNa3mI',
    },
    feedback: {
      genericError: 'An error has occurred, please try again later.',
      noName: 'Enter your name.',
      noEmail: 'Enter your e-mail address.',
      noMessage: 'Enter a message.',
      success: 'Your message has been sent!',
    },
  },
}

export default localization



// WEBPACK FOOTER //
// ./src/components/ContactForm/localization.js